import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation, Navigate } from 'react-router-dom';
import { HOME } from '../constants/routes';

const getNestedValue = (obj, path) => {
  if (!obj || !path || typeof path !== 'string') return undefined;
  return path.split('.').reduce((acc, key) => acc?.[key], obj);
};

export const ProtectedRoute = ({
  children,
  checks,
  locationChecks,
  redirectTo
}) => {
  const reduxState = useSelector((state) => state);
  const location = useLocation();

  const safeChecks = Array.isArray(checks) ? checks : [];
  const safeLocationChecks = Array.isArray(locationChecks) ? locationChecks : [];
  const safeRedirectTo = redirectTo || HOME;

  const isReduxValid = safeChecks.every((check) => {
    if (!check || typeof check !== 'object') return false;
    const { slice, key = '_id' } = check;
    if (!slice || typeof slice !== 'string') return false;
    const sliceState = reduxState?.[slice];
    return getNestedValue(sliceState, key);
  });

  const isLocationValid = safeLocationChecks.every((key) => {
    if (!key || typeof key !== 'string') return false;
    return getNestedValue(location.state, key);
  });

  if (!isReduxValid || !isLocationValid) {
    return <Navigate to={safeRedirectTo} replace />;
  }

  return children || null;
};
